export const LastDeclaredDate = "Declared Date:";

export const LastDeclaredShifts = "Declared Shift(s):";

export const LastDeclaredMissingData = "You have not declared your availability for any shifts."